import React from "react";
import { FileText, ImageIcon, Download } from "lucide-react";
import { GRNAttachmentModel } from "../model/warehouse_inward_models";

interface InwardAttachmentListProps {
  attachments?: GRNAttachmentModel[];
  title?: string;
}

const getIcon = (type: string) => {
  if (type.includes("pdf")) return <FileText size={16} />;
  if (type.includes("image")) return <ImageIcon size={16} />;
  return <FileText size={16} />;
};

export const InwardAttachmentList: React.FC<InwardAttachmentListProps> = ({
  attachments = [],
  title = "Invoice Attachments",
}) => {
  if (!attachments.length) {
    return <p className="text-sm text-gray-500">No attachments available</p>;
  }

  const grouped = attachments.reduce<Record<string, GRNAttachmentModel[]>>(
    (acc, att) => {
      if (!acc[att.voucher_id]) acc[att.voucher_id] = [];
      acc[att.voucher_id].push(att);
      return acc;
    },
    {},
  );

  return (
    <div id="warehouse-inward-attachment-list" className="space-y-4">
      <h3 className="text-sm font-semibold">{title}</h3>

      {Object.entries(grouped).map(([voucherId, files]) => {
        const invoiceNo = files[0]?.invoice_number || "-";

        return (
          <div key={voucherId} className="border rounded-lg bg-white">
            {/* Header */}
            <div className="px-4 py-2 border-b bg-white rounded-t-lg">
              <div className="flex flex-wrap gap-6 text-sm">
                <div>
                  <span className="text-gray-500">Invoice No:</span>
                  <span className="ml-1 font-semibold">{invoiceNo}</span>
                </div>
              </div>
            </div>

            {/* Files */}
            <div className="p-3 space-y-1">
              {files.map((att) => (
                <div
                  key={att.id}
                  className="flex items-center justify-between text-sm bg-white rounded px-3 py-2"
                >
                  <div className="flex items-center gap-2 truncate">
                    {getIcon(att.type)}
                    <span className="truncate">{att.filename}</span>
                  </div>

                  <a
                    id={`warehouse-inward-attachment-view-${voucherId}-${att.id}`}
                    href={att.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline flex items-center gap-1 text-xs"
                  >
                    <Download size={14} />
                    View
                  </a>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
